import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { toast } from 'react-toastify';

import API from '../api';
import * as types from './actionTypes';
import { ISettingsStore } from './store';

export const setSettings = (settings: ISettingsStore): types.ISetSettings => ({
  payload: settings,
  type: types.SET_SETTINGS,
});

export const setViewType = (viewType: string): types.ISetViewType => ({
  payload: viewType,
  type: types.SET_VIEWTYPE,
});

export const setLinksPerPage = (
  linksPerPage: number
): types.ISetLinksPerPage => ({
  payload: linksPerPage,
  type: types.SET_LINKS_PER_PAGE,
});

export const fetchSettings = (): ThunkAction<
  Promise<void>,
  {},
  {},
  types.ISettingsActions
> => async (dispatch: ThunkDispatch<{}, {}, types.ISettingsActions>) => {
  try {
    const settings = await API.SETTINGS.get();
    document.title = settings.applicationName;
    dispatch(setSettings(settings));
  } catch (error) {
    console.warn('API.SETTINGS.get error:', error.message);

    toast.error(
      'Network error. Please check your connection and refresh the page.',
      {
        autoClose: false,
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/settings/actionCreators.ts